<div class="loader" *ngIf="isLoading$ | async">
  <div class="loader__content">
    <span class="loader__icon" aria-hidden="true">i</span>
    <p class="loader__message">{{loaderMessage | translate}}</p>
  </div>
</div>
